import { useState, type ReactNode } from "react";
import "./Tabs.scss";
import { logout } from "../../useCases/auth";
import type { Auth, User } from "firebase/auth";
import { LOCAL_STORAGE_KEYS } from "../../constants";

export type Tab<TabId> = {
  id: TabId;
  label: string;
  content: ReactNode;
};

type TabsProps<TabId> = {
  initialTabId: TabId;
  tabs: Tab<TabId>[];
  auth: Auth;
  loggedInUser: User;
};

export const Tabs = <TabId extends string>(props: TabsProps<TabId>) => {
  const [activeTab, setActiveTab] = useState<TabId>(props.initialTabId);

  return (
    <div className="tabs">
      <div className="tabs-header">
        <div className="tabs-header-left">
          {props.tabs.map((tab) => (
            <div
              key={`${tab.id}`}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className="logo">
          <img src={"/logo.png"} alt="logo" />
        </div>
        <div className="tabs-header-right">
          <span className="email">
            {localStorage.getItem(LOCAL_STORAGE_KEYS.USER_NAME)} |{" "}
            {localStorage.getItem(LOCAL_STORAGE_KEYS.USER_DISTRIBUTOR_NAME)}
          </span>
          <div className="logout" onClick={() => logout(props.auth)}>
            Cerrar sesión
          </div>
        </div>
      </div>
      <div className="tabs-content">
        {props.tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};
